import React, { useEffect } from 'react';
import { AuthRelay } from '../components/AuthLayout';

export default function RaonPopup() {
  useEffect(() => {
    
    // 1. 인증 결과가 쿼리 파라미터로 들어온 경우 postMessage
    const params = new URLSearchParams(window.location.search);
    const rslt_name = params.get('rslt_name');
    const tel_no = params.get('tel_no');
    const birthday = params.get('birthday');
    const sex_cd = params.get('sex_cd');
    const di = params.get('di');
    const eci = params.get('eci');
    const authType = params.get('authType') || 'password_reset';
    const userIndex = params.get('userIndex');
    // 실제 인증 결과 파라미터명에 맞게 수정 필요
    if (rslt_name && tel_no) {
      // console.log('[RaonPopup] 인증 결과 발견, postMessage 전송:', {
      //   rslt_name, tel_no, birthday, sex_cd, di, eci, authType, userIndex
      // });
      
      if (window.opener) {
        const messageData = { 
          rslt_name, 
          tel_no, 
          birthday, 
          sex_cd, 
          di, 
          eci, 
          authType, 
          userIndex 
        };
        
        // console.log('[RaonPopup] postMessage 데이터:', messageData);
        window.opener.postMessage(messageData, window.location.origin);
        setTimeout(() => window.close(), 500);
      }
      return;
    }
    // 2. 현재 경로가 절대경로가 아니면 절대경로로 이동 (내부 라우트 보장)
    const { protocol, hostname, pathname } = window.location;
    const origin = `${protocol}//${hostname}`;
    const expectedPath = `/cert/raon/popup`;
    if (!pathname.startsWith(expectedPath)) {
      window.location.replace(`${origin}${expectedPath}${window.location.search}`);
      return;
    }
    // 3. 인증 결과가 없으면 외부 인증 URL로 이동 (예시)
    const externalUrl = `https://raon-external-url.com${window.location.search}`;
    window.location.replace(externalUrl);
  }, []);

  return <AuthRelay title="간편인증 진행 중..." description="잠시만 기다려 주세요. 인증 기관 화면으로 넘어갑니다." />;
} 